// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__leZdK","error":"Textarea_error___1HJL","readonly":"Textarea_readonly__39w6N","disabled":"Textarea_disabled__gP4mh"};